/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_ASSETS_PERIODS, GET_ASSETS_PERIODS } from 'src/actions/assetsPeriodActions';

const initialState = {
  items: [],
  isFetching: false,
  message: ''
};

const assetsPeriodReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ASSETS_PERIODS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_ASSETS_PERIODS: {
      const { assetsPeriods, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = assetsPeriods;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default assetsPeriodReducer;
